
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './BackgroundCircles.module.scss';
import { useGlobalState } from '../../../../globalStates/ProfileThemeState';
const propTypes = {
    house: PropTypes.oneOf(['slytherin', 'hufflepuff', 'ravenclaw', 'gryffindor', 'nohouse'])
        .isRequired
};
const BackgroundCircles = ({ house }) => {
    const [houseAnimationStarted] = useGlobalState('houseAnimationStarted');
    const [firstLoadHouse] = useGlobalState('firstLoadHouse');
    return (<>
      {((firstLoadHouse && houseAnimationStarted) || !firstLoadHouse) && (<div className={cx(s.circle, s[house])}/>)}
      {firstLoadHouse && !houseAnimationStarted && <div className={cx(s.circle, s.nohouse)}/>}
    </>);
};
BackgroundCircles.propTypes = propTypes;
export default BackgroundCircles;

    async function __Next_Translate__getStaticProps__195ca0f1681__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/BackgroundCircles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f1681__ as getStaticProps }
  